/**
 * @props className (optional): 'mt20' (String)
 * @props label: 'Shadow' (String)
 * @props value: { type, shadow: [{hOffset, vOffset, blur, spreed, color, isInset}] } (Object)
 * @props onChange: (Function)
 * @props defaults (optional): { shadow: [{hOffset, vOffset, blur, spreed, color, isInset}] } (Object)
 * @return Shadow Properties (Object)
 */

import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { Dropdown, PanelRow, ToggleControl, __experimentalUnitControl as UnitControl, Button, Dashicon } from '@wordpress/components';

import Title from './Title';
import BColor from './BColor';
import BtnGroup from './BtnGroup';
import { pxUnit, emUnit, remUnit } from './Helper/options';
import { gearIcon } from './Helper/icons';

const MultiShadowControl = props => {
	const { className = '', label = __('Shadow', 'bplugins'), value, onChange, type, defaults = {}, produce } = props;

	const [activeIndex, setActiveIndex] = useState(0);

	const defaultVal = { shadow: [{ hOffset: '0px', vOffset: '0px', blur: '0px', spreed: '0px', color: '#7090b0', isInset: false }] }
	const shadowValue = value?.['shadow'] || defaults?.['shadow'] || defaultVal['shadow'];

	const getDefault = (property) => defaults?.['shadow']?.[activeIndex]?.[property] || defaultVal['shadow'][0][property];

	const resetValue = (property) => <Button icon='image-rotate' className='bPlResetVal' onClick={() => updateShadow(property, getDefault(property))} />

	const updateShadow = (property, val) => {
		const newShadow = produce(shadowValue, draft => {
			draft[activeIndex][property] = val;
		})
		onChange({ ...value, ['shadow']: newShadow });
	}

	const duplicateShadow = e => {
		e.preventDefault();

		onChange({ ...value, ['shadow']: [...shadowValue.slice(0, activeIndex), { ...shadowValue[activeIndex] }, ...shadowValue.slice(activeIndex)] });

		setActiveIndex(activeIndex + 1);
	}

	const removeShadow = e => {
		e.preventDefault();

		onChange({ ...value, ['shadow']: [...shadowValue.slice(0, activeIndex), ...shadowValue.slice(activeIndex + 1)] });

		setActiveIndex(0 === activeIndex ? 0 : activeIndex - 1);
	}

	// Add styles
	// useEffect(() => {
	// 	let allStyles = '';

	// 	shadowValue.map((item, index) => {
	// 		const { hOffset, vOffset, blur, spreed, color, isInset } = item;
	// 		const inset = isInset ? 'inset' : '';
	// 		const offsetBlur = `${hOffset || ''} ${vOffset || ''} ${blur || ''}`;
	// 		const isComa = index + 1 >= shadowValue.length ? '' : ', ';

	// 		allStyles += 'text' === type ? `${offsetBlur} ${color || ''}${isComa}` : `${offsetBlur} ${spreed || ''} ${color || ''} ${inset}${isComa}`;
	// 	});

	// 	const initialObj = { shadow: shadowValue }

	// 	onChange({ ...value, ...initialObj, styles: allStyles.replace(/\s+/g, ' ').trim() });
	// }, [shadowValue]);


	const { hOffset = '', vOffset = '', blur = '', spreed = '', color = '', isInset = false } = shadowValue[activeIndex] || {};

	return <PanelRow className={`bPlDropdown ${className}`}>
		<Title className='mt5'>{label}</Title>

		<Dropdown className='bPlDropdownContainer' contentClassName='bPlDropdownPopover' position='bottom right'
			renderToggle={({ isOpen, onToggle }) => <Button icon='edit' onClick={() => { onToggle(), setActiveIndex(0) }} aria-expanded={isOpen} />}
			renderContent={() => <>
				{1 < shadowValue.length && <PanelRow>
					<Title className='mt5'>{__('Shadow:', 'bplugins')}</Title>
					<BtnGroup value={activeIndex} onChange={val => setActiveIndex(val)} options={
						shadowValue.map((_, index) => ({ label: index + 1 + '', value: index })) || [{ label: 1, value: 0 }]
					} />
				</PanelRow>}

				{null !== activeIndex && <>
					<PanelRow>
						<UnitControl label={__('Horizontal Offset:', 'bplugins')} labelPosition='left' value={hOffset} onChange={val => updateShadow('hOffset', val)} units={[pxUnit(), emUnit(), remUnit()]} />
						{hOffset && hOffset !== getDefault('hOffset') && resetValue('hOffset')}
					</PanelRow>

					<PanelRow>
						<UnitControl label={__('Vertical Offset:', 'bplugins')} labelPosition='left' value={vOffset} onChange={val => updateShadow('vOffset', val)} units={[pxUnit(), emUnit(), remUnit()]} />
						{vOffset && vOffset !== getDefault('vOffset') && resetValue('vOffset')}
					</PanelRow>

					<PanelRow>
						<UnitControl label={__('Blur:', 'bplugins')} labelPosition='left' value={blur} onChange={val => updateShadow('blur', val)} units={[pxUnit(), emUnit(), remUnit()]} />
						{blur && blur !== getDefault('blur') && resetValue('blur')}
					</PanelRow>
					<small>{__('Blur cannot be negative value!', 'bplugins')}</small>

					{'box' === type && <PanelRow>
						<UnitControl label={__('Spreed:', 'bplugins')} labelPosition='left' value={spreed} onChange={val => updateShadow('spreed', val)} units={[pxUnit(), emUnit(), remUnit()]} />
						{spreed && spreed !== getDefault('spreed') && resetValue('spreed')}
					</PanelRow>}

					<BColor label={__('Color:', 'bplugins')} value={color} onChange={val => updateShadow('color', val)} defaultColor={getDefault('color')} />

					{'box' === type && <ToggleControl label={__('Shadow Inset?', 'bplugins')} checked={isInset} onChange={val => updateShadow('isInset', val)} />}

					<PanelRow className='itemAction mt20'>
						{1 < shadowValue?.length && <Button className='removeItem' label={__('Remove', 'bplugins')} onClick={removeShadow}><Dashicon icon='no' />{__('Remove', 'bplugins')}</Button>}

						<Button className='duplicateItem' label={__('Duplicate', 'bplugins')} onClick={duplicateShadow}>{gearIcon}{__('Duplicate', 'bplugins')}</Button>
					</PanelRow>
				</>}

				<br />
				<div className='addItem'>
					<Button label={__('Add New Shadow', 'bplugins')} onClick={() => onChange({ ...value, ['shadow']: [...shadowValue, defaultVal.shadow[0]] })}><Dashicon icon='plus' />{__('Add New Shadow', 'bplugins')}</Button>
				</div>
			</>}
		/>
	</PanelRow>;
};
export default MultiShadowControl;